<!--
    @修改人：黎柏祺
    @修改时间：2018-11-28
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @修改人：黎柏祺
    @修改时间：2018-05-10
    @修改描述：增加第三方告警，修改列表显示，新增按钮功能修改
    @版本:v1.0.16
    --------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 告警策略页
    -->
<template>
  <div class="alarmStrategy__content">
    <div class="alarmStrategy__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('logComponentManage.site')">
          <g-select :list="siteList" v-model="form.siteCode"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmType')">
          <g-select :list="select_alarmType" v-model="form.alarmType" :defaultAll="defaultAll"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmName')">
          <el-input v-model="form.alarmName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmCode')">
          <el-input v-model="form.alarmCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmKey')">
          <el-input v-model="form.kpiKey"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.appGroup')">
          <el-input v-model="form.group"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" v-g-rac="gRac('alarmStrategy_search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_addAlarm('1')" v-g-rac="gRac('alarmStrategy_add')">{{ $t('alarmStrategy.addKpiAlarm') }}</el-button>
          <el-button type="primary" @click="e_addAlarm('2')" v-g-rac="gRac('alarmStrategy_add')">{{ $t('alarmStrategy.addThirdAlarm') }}</el-button>
          <el-button type="primary" @click="e_addAlarm('3')" v-g-rac="gRac('alarmStrategy_add')">{{ $t('alarmStrategy.addalarmRegist') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="alarmStrategy__table">
      <el-table-extend
        :data="tData" 
        :head="tHead"
        :currentChange="tCurrentChange"
        :sizeChange="tSizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>
  </div>
</template>
<script>
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import rac from '@/plugins/rac-mixin.js'
  import alarmStrategyBiz from '@/logic/systemSetting/alarmStrategyBiz.js'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [dic, table, rac],
    data () {
      const that = this
      return {
        select_alarmType: {},
        siteList: {},
        currentPage: 1,
        perPageCount: 10,
        defaultAll: true,
        form: {
          siteCode: '',
          alarmName: '',
          alarmCode: '',
          alarmType: ''
        },
        tableControl: [{
          label: that.$t('common.delete'),
          callback: that.e_delete,
          rac: () => that.gRac('alarmStrategy_delete')
        },
        {
          label: that.$t('common.edit'),
          callback: that.e_edit,
          rac: () => that.gRac('alarmStrategy_amend')
        }]
      }
    },
    methods: {
      async waitAlarmTypeList () {
        await this.dGetDictionaryByCode('alarmType')
        this.select_alarmType = { ...this.dDictionary.alarmType }
      },
      getSiteList () {
        if (Object.keys(this.siteList).length > 0) {
          this.e_search()
        } else {
          SiteListBiz.siteList({perPageCount: 500}).then((data) => {
            let list = {}
            data.dataList.map((item) => {
              list[item.siteCode] = item.name
            })
            this.siteList = list
            this.form.siteCode = Object.keys(list)[0]
            this.initTable()
            this.e_search()
          })
        }
      },
      initTable () {
        this.tInitTable({
          lanKey: 'alarmStrategy.table',
          head: ['appName', 'alarmName', 'alarmCode', 'kpiKey', 'enable'],
          requestFun: this.search
        })
      },
      e_addAlarm (type) {
        this.$router.push({ path: '/home/alarmStrategy/addStrategy', query: { sourceType: type } })
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        Object.keys(this.form).forEach((item) => {
          if (this.form[item] === '') {
            delete reqData[item]
          }
        })
        alarmStrategyBiz.findAll(reqData).then((data) => {
          data.dataList.forEach((item, index) => {
            item.enable = item.enable ? this.$t('alarmStrategy.yes') : this.$t('alarmStrategy.no')
          })
          this.tData = data
        })
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      e_edit (data) {
        this.$router.push({ path: '/home/alarmStrategy/editStrategy', query: {alarmCode: data.alarmCode} })
      },
      e_delete (data) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          alarmStrategyBiz.deleteStrategy({ id: data.id }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.e_search()
            }, 500)
          })
        }).catch(() => {})
      },
      e_init () {
        this.waitAlarmTypeList()
        this.getSiteList()
      }
    },
    watch: {
      '$route' (newV, oldV) {
        if (oldV.name === 'addStrategy' || oldV.name === 'editStrategy') {
          this.e_init()
        }
      }
    },
    mounted () {
      this.e_init()
    }
  }
</script>